<nz-form-item [formGroup]="formConfig.parentForm">
	<nz-form-label [nzSpan]="6">{{ schema?.title || schemaKey | translate }}</nz-form-label>
	<nz-form-control [nzSpan]="18" *ngIf="resolvedSchema">
		<nz-select nzMode="multiple" nzPlaceHolder="{{ 'actions.select' | translate : {selectItem : 'user.roles' | translate } }}" formControlName="{{ key }}"
					[nzOptions]="items" [(ngModel)]="value" (ngModelChange)="setValid($event)"></nz-select>
	</nz-form-control>
</nz-form-item>

